import { createContext } from "react";

export type AppDebugSettings = {
	showHitBox: boolean;
	showLoggingOverlay: boolean;
	showVolumeOverlay: boolean;
};

export const AppDebugSettings = createContext<AppDebugSettings>({
	showHitBox: false,
	showLoggingOverlay: false,
	showVolumeOverlay: false,
});
